import React from "react";
import AdminShowReview from "./AdminShowReview";

// name,
//   title,
//   review,
//   imgs,
//   uid,
//   productId,
//   link,
//   productName,
//   refresh,
//   created,

const AdminReviewsPartials = (props) => {
  const reviews = props.reviews;
  console.log("reviews", reviews);
  return (
    <div>
      {reviews.map((review) => (
        <AdminShowReview
          reviewDBName={review.reviewDBName}
          id={review.id}
          created={review.created}
          rating={review.rating}
          name={review.name}
          title={review.title}
          review={review.comment}
          imgs={review.images}
          uid={review.uid}
          productId={review.productId}
          link={review.link}
          productName={review.productName}
          refresh={props.refresh}
          admin={review.admin}
        />
      ))}
    </div>
  );
};

export default AdminReviewsPartials;
